import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { setRequireCloseModal } from '../../../../slices/warehouseItem/reducer';
import { addNewWarehouseItem, checkWarehouseItemExists, updateWarehouseItem } from '../../../../slices/thunks';
import OSelect from '../../../../Components/OElements/OSelect';
import { getUnitMeasurementList } from '../../../../helpers/residue/backend_helper'; 
import { getWarehouseCategoryList } from '../../../../helpers/warehouse/backend_helper';




const ItemForm = ({
	dataItem,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorItem = createSelector(
		state => state.WarehouseItems,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal,
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal,
	} = useSelector(selectorItem);

	// validation
	const validation = useFormik({
		enableReinitialize: true,
		initialValues: {
			name: (dataItem && dataItem.name) || '',
			stock: (dataItem && dataItem.stock) || '',
			warehouse_category_id: (dataItem && dataItem.warehouse_category_id) || '',
			unit_measurement_id: (dataItem && dataItem.unit_measurement_id) || '',
			disabled: (dataItem && dataItem.disabled) || false,
			warehouse_id: '6682d37297e3dfde36571b66'
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test({
					name: 'name-exists-check',
					message: 'Item ya existe',
					test: async function (value) {
						if (value) {
							const exists = await dispatch(checkWarehouseItemExists(value));
							if (exists.payload == true) {
								return this.createError({ message: 'Item ya existe' });
							}
						}
						return true;
					}
				}),
			warehouse_category_id: Yup.string().required('Campo requerido'),
			unit_measurement_id: Yup.string().required('Campo requerido'),
			stock: Yup.number().required('Campo requerido'),
		}),
		onSubmit: values => {
			const itemData = {
				name: values.name,
				stock: values.stock,
				warehouse_category_id: values.warehouse_category_id,
				unit_measurement_id: values.unit_measurement_id,
				disabled: values.disabled,
				warehouse_id: values.warehouse_id
			};
			
			if (isEdit) {
				const updatedItem = {
					...itemData,
					_id: dataItem._id,
				};
				dispatch(updateWarehouseItem(updatedItem));
			} else {
				dispatch(addNewWarehouseItem(itemData));
			}
		},
	});
	

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	const [selectedWarehouseCategory, setSelectedWarehouseCategory] = useState(null);
	const handleWarehouseCategorySelect = (optionSelected) => {
		setSelectedWarehouseCategory(optionSelected);
	};	

	const [selectedUnitMeasurement, setSelectedUnitMeasurement] = useState(null);
	const handleUnitMeasurementSelected = (optionSelected) => {
		setSelectedUnitMeasurement(optionSelected);
	};

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if(validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				{/* <TabContent activeTab={activeTab}>
					<TabPane tabId='1'> */}
				<Row className='g-3'>
					<Col lg={12}>
						<OSelect
							label='Categoría'
							id='warehouse_category_id'
							name='warehouse_category_id'
							value={validation.values.warehouse_category_id || ''}
							onSelect={handleWarehouseCategorySelect}
							requestApi={() => getWarehouseCategoryList()}
							disabled={false}
							validation={validation}
						/>
					</Col>
					<Col lg={12}>
						<Label for='name' className='form-label'>
							Nombre del item
						</Label>
						<Input
							name='name'
							id='name'
							className='form-control'
							placeholder='Ingrese el nombre del item'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.name || ''}
							invalid={
								validation.touched.name &&
									validation.errors.name
									? true
									: false
							}
						/>
						{
							validation.touched.name &&
								validation.errors.name ? (
								<FormFeedback type='invalid'>
									{validation.errors.name}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={6}>
						<OSelect
							label='Unidad de Medida'
							id='unit_measurement_id'
							name='unit_measurement_id'
							value={validation.values.unit_measurement_id || ''}
							onSelect={handleUnitMeasurementSelected}
							requestApi={() => getUnitMeasurementList()}
							disabled={false}
							validation={validation}
						/>
					</Col>
					<Col lg={6}>
						<Label for='stock' className='form-label'>
							Saldo
						</Label>
						<Input
							name='stock'
							id='stock'
							className='form-control'
							placeholder='Ingrese el stock'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.stock || ''}
							invalid={
								validation.touched.stock &&
									validation.errors.stock
									? true
									: false
							}
						/>
						{
							validation.touched.stock &&
								validation.errors.stock ? (
								<FormFeedback type='invalid'>
									{validation.errors.stock}
								</FormFeedback>
							) : null
						}
					</Col>
				</Row>
				{/* </TabPane>
				</TabContent> */}
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isLoading ||
							isAdding ||
							isUpdating
						}
					>
						{
							isLoading ||
							isAdding ||
							isUpdating
							? (
								<i className="label-icon"><Spinner size='sm' /></i>
							) 
							: <i className="ri-save-3-line label-icon"></i>
							}
						{isEdit ? 'Editar' : 'Agregar'} Item
					</button>
				</div>
			</div>
		</Form>
	);
};

export default ItemForm;
